export default __webpack_public_path__ + "static/media/p21.a6106626.jpeg";